import React, { useEffect, useRef, useState } from 'react';
import { Card, CardBody, Container, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { MaterialReactTable } from 'material-react-table';
import { handleExportData } from '../../Utils/ExportToCsv';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllUom } from '../../../slices/uom/thunk';
import { uomColoumns } from './constants/coloumn';
import { Loader } from '../../Utils/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { setEditSuccessMessage, setSuccessMessage } from '../../../slices/toastMessage/action';
import { PAGE_TITLES } from '../../Common/constants';
import { MenuItem } from "@mui/material";
import CommonModal from "../../Utils/CommonModal";
import { deleteUom } from '../../../slices/uom/deleteUom/thunk';
import { useColumnSettings } from '../../Utils/useColumnSettings';
import { getView } from '../../../slices/View/thunk';
import { bulkDelete } from '../../../slices/BulkDelete/thunk';
import { UmoForm } from './UmoForm';
import { getUomById } from "../../../slices/uom/getUomByName/thunk";
import { hasPermission } from '../../Utils/UtilityFunctions';

function UomListings() {
    const [loading, setLoading] = useState(false);
    const [messageForPopUp, setMessageForPopUp] = useState('');
    const [uomName, setUomName] = useState("");
    const [modal, setModal] = useState(false);
    const [modalForBulkDelete, setModalForBulkDelete] = useState(false)
    const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState()
    const [uomArray, setUomArray] = useState([]);
    const [selectAllUoms, setSelectAllUoms] = useState(false)
    const [selectedUom, setSelectedUom] = useState([])
    const checkboxRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage);
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    const uom = useSelector((state) => state.Uom.uom);
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const uomPermission = hasPermission(permissionsMap, "pricing", "uom")
    const uomInventoryPermission = hasPermission(permissionsMap, "configuration", "uom")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")
    const isMobile = window.innerWidth <= 768;
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedUmo, setSelectedUmo] = useState("");
    const [refresh, setRefresh] = useState(false)
    const toggleModals = () => {
        setModalOpen((prev) => !prev);
    };
    const uomLabel = uomInventoryPermission?.has("list") ? "Unit" : "UOM";

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = selectedUom.length > 0 && selectedUom.length < uom.length;
        }
        setSelectAllUoms(
            selectedUom?.length > 0 && uom?.length > 0 && selectedUom?.length === uom?.length
        );
    }, [selectedUom, uom.length, setSelectAllUoms]);

    const columns = uomColoumns(selectAllUoms, setSelectAllUoms, uom, setSelectedUom, selectedUom, checkboxRef, isMobile);

    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar,
        CustomViewModal
    } = useColumnSettings('uom', columns);

    useEffect(() => {
        dispatch(fetchAllUom(setLoading));
        dispatch(getView(setLoading));
    }, [dispatch, refresh]);

useEffect(() => {
    if (showSuccessMessage) {
        toast.success(`${uomLabel} Created Successfully`);
        dispatch(setSuccessMessage(false));
    }

    if (showEditSuccessMessage) {
        toast.success(`${uomLabel} Updated Successfully`);
        dispatch(setEditSuccessMessage(false));
    }
}, [showSuccessMessage, showEditSuccessMessage, dispatch, uomLabel]);

    const navigateToAddUnit = () => {
        let path = "/create-unit";
        navigate(path);
    };

    const toggleModal = (id, singleOrMulti) => {
        if (singleOrMulti === "single") {
            setUomName(id);
            setModal(!modal);
        }
        else {
            setSelectedRowsForBulkDelete(id)
            setModalForBulkDelete(!modalForBulkDelete)
        }
        document.body.style.overflow = 'auto';
    };

    return (
        <React.Fragment>
            <div id="csms" className="page-content bg-white">
                <Container fluid>
                   <BreadCrumb
    title={
        uomInventoryPermission?.has("list")
            ? PAGE_TITLES.UNIT_LIST
            : PAGE_TITLES.UOM_LIST
    }
    pageTitle={PAGE_TITLES.PRICING}
/>
                    <ToastContainer position='top-center' />

                    <div className="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-lg-center gap-2 mb-1 mt-0">
                        <div className="d-flex flex-row gap-2">
                            <h5 className="rv-page-title p-2">
    {uomInventoryPermission?.has("list") ? "Unit List" : "UOM List"}
</h5>
                        </div>
                        <div className="d-flex align-items-center">
                            {(uomPermission?.has("export") || uomInventoryPermission?.has("export")) &&
                                <Button
                                    color="secondary"
                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => {
                                        handleExportData(uom);
                                    }}
                                >
                                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                </Button>}
                            {(uomPermission?.has("create") || uomInventoryPermission?.has("create")) &&
                                <Button
                                    color="secondary"
                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 me-2 w-100 w-md-auto text-nowrap"
                                    onClick={() => {
                                        setModalOpen(true);
                                        setIsEditMode(false);
                                    }}
                                >
                                    <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                   <span className="ps-2 ms-2 me-1">Add {uomLabel}</span>
                                </Button>
                            }
                            {/* {selectedUom?.length ? (
<Button
color="main-color"
className="btn me-2"
onClick={() => {
const names = selectedUom.map((row) => row.name);
let uniqueUoms = Array.from(new Set(names));
setUomArray(uniqueUoms);
setMessageForPopUp(
`Are you sure you want to delete the selected items?`
);
toggleModal(selectedUom, "multi");
}}
>
Delete
</Button>
) : null} */}
                            {(selectedUom?.length && (uomPermission?.has("bulkdelete") || uomInventoryPermission?.has("bulkdelete"))) ?
                                <Button
                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    color="main-color"
                                    onClick={() => {
                                        const names = selectedUom.map(row => row.name);
                                        let uniqueUoms = Array.from(new Set(names))
                                        setUomArray(uniqueUoms);
                                        setMessageForPopUp(`Are you sure you want to delete the selected items?`)
                                        toggleModal(selectedUom, "multi")
                                    }}
                                >
                                    <i className="ri-close-fill label-icon align-middle fs-16 me-1"></i>
                                    <span className="ps-2 ms-2 me-1">Delete</span>
                                </Button> : null}
                            {viewPermission && viewPermission?.has("view") &&
                                <i className="ri-settings-2-line fs-4" onClick={toggleSettingsModal}></i>}
                        </div>
                        {CustomViewModal()}
                    </div>
                    <Row>
                        <Col lg={12}>
                            <div className="listingjs-table" id="customerList">
                                <div className="container-fluid px-0">
                                    <div className="disable-margin-card table-responsive table-customer border w-100"
                                    style={{ borderRadius: "4px" }}>
                                        {loading && <Loader />}
                                        {uom ? (
                                            <>
                                                <MaterialReactTable
                                                    muiTablePaperProps={{
                                                        sx: {
                                                            padding: 0,
                                                        },
                                                    }}
                                                    icons={{
                                                        DragHandleIcon: () => (
                                                            <i className="ri-drag-move-fill" />
                                                        ),
                                                    }}
                                                    muiSelectCheckboxProps={{
                                                        color: "warning",
                                                    }}
                                                    muiSelectAllCheckboxProps={{
                                                        color: "warning",
                                                    }}
                                                    positionToolbarAlertBanner="none"
                                                    enableTopToolbar={false}
                                                    initialState={{
                                                        columnOrder: [
                                                            "checkbox",
                                                            "mrt-row-actions",
                                                            "Name",
                                                            "Value Type",
                                                        ],
                                                    }}
                                                    columns={columns.filter((column) =>
                                                        viewColumns?.includes(
                                                            column.accessorKey || column.header
                                                        )
                                                    )}
                                                    data={uom}
                                                    enableColumnActions={true}
                                                    enableColumnOrdering={true}
                                                    enableColumnDragging={false}
                                                    enableRowActions={true}
                                                    displayColumnDefOptions={{
                                                        "mrt-row-actions": {
                                                            header: "",
                                                            enableHiding: true,
                                                            size: isMobile ? 53 : 15,
                                                            grow: true,
                                                        },
                                                    }}
                                                    defaultColumn={{
                                                        // minSize: 1,
                                                        maxSize: 9001,
                                                        muiTableBodyCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif",
                                                            },
                                                        },
                                                        muiTableHeadCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif",
                                                            },
                                                        },
                                                    }}
                                                    layoutMode="grid"
                                                    renderRowActionMenuItems={({ closeMenu, row }) => [
                                                        (uomPermission?.has("update") || uomInventoryPermission?.has("update")) ?
                                                            <MenuItem
                                                                className="row-options px-4 py-2"
                                                                key={`${row.index}.2`}
                                                                onClick={() => {
                                                                    setSelectedUmo(row.original);
                                                                    setModalOpen(true);
                                                                    setIsEditMode(true);
                                                                    dispatch(
                                                                        getUomById(setLoading, row.original.name)
                                                                    );
                                                                    closeMenu();
                                                                }}
                                                            >
                                                                <i className="bx bxs-edit me-3" /> Edit
                                                            </MenuItem> : null,
                                                        (uomPermission?.has("delete") || uomInventoryPermission?.has("delete")) ?
                                                            <MenuItem
                                                                className="row-options px-4 py-2"
                                                                key="delete"
                                                                onClick={() => {
                                                                    setMessageForPopUp(
                                                                        `Are you sure you want to Delete this UOM "${row.original.name}"?`
                                                                    );
                                                                    toggleModal(row, "single");
                                                                    closeMenu();
                                                                }}
                                                            >
                                                                <i className="ri ri-delete-bin-5-line me-3" />{" "}
                                                                Delete
                                                            </MenuItem> : null,
                                                    ]}
                                                    enableDensityToggle={false}
                                                />
                                            </>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {CustomViewModal()}
                    </Row>
                </Container>
                <CommonModal messageForPopUp={messageForPopUp} toggle={() => { if (modal) { toggleModal(uomName, "single") } else { toggleModal(selectedRowsForBulkDelete, "multi") } }
                } modalHeader={"Delete UOM"} open={modalForBulkDelete ? modalForBulkDelete : modal} buttonText={"Delete"} modalAction={() => {
                    if (modal) {
                        dispatch(deleteUom(uomName.original.name, setLoading, navigate));
                        toggleModal(uomName, "single");
                    }
                    else {
                        let jsonObj = { ids: uomArray, type: "UOM" }
                        dispatch(bulkDelete(jsonObj, setLoading))
                        setSelectAllUoms(false)
                        setSelectedUom([])
                        toggleModal(selectedRowsForBulkDelete, "mutli");
                    }
                }} />

                <Modal
                    isOpen={modalOpen}
                    toggle={toggleModals}
                    centered
                    size="md"
                    className="custom-modal"
                >
                    <ModalHeader
  toggle={toggleModals}
  style={{
    borderBottom: uomInventoryPermission?.has("list")
      ? "1px solid #FD7545"
      : "",
    padding: "16px 20px",
    position: "relative",
  }}
>
  <span
    style={{
      position: uomInventoryPermission?.has("list")
        ? "static"
        : "absolute",
      left: uomInventoryPermission?.has("list") ? "auto" : "50%",
      transform: uomInventoryPermission?.has("list")
        ? "none"
        : "translateX(-50%)",
      color: uomInventoryPermission?.has("list")
        ? "#FD7545"
        : "inherit",
      fontWeight: 600,
    }}
  >
    {isEditMode ? `Edit ${uomLabel}` : `Add ${uomLabel}`}
  </span>
</ModalHeader>
                    <ModalBody>
                        <UmoForm
                            toggle={toggleModals}
                            initialAIUomValues={null}
                            isEditMode={isEditMode}
                            initialData={isEditMode ? selectedUmo : null}
                            triggerRefresh={() => {
                                setRefresh(!refresh)
                            }}
                        />
                    </ModalBody>
                </Modal>
            </div>
        </React.Fragment>
    );
}

export default UomListings;